var map = {
	"@ehs/carbon-emission/basic-configuration/api-management/api-management.module": [
		"./src/app/ehs/carbon-emission/basic-configuration/api-management/api-management.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-api-m~811ec30c",
		"common",
		"ehs-carbon-emission-basic-configuration-api-management-api-management-module"
	],
	"@ehs/carbon-emission/basic-configuration/basic-configuration.module": [
		"./src/app/ehs/carbon-emission/basic-configuration/basic-configuration.module.ts",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~94fe8c80",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~b7bcf106",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~b0586a80",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~d00498ce",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-api-m~811ec30c",
		"common",
		"ehs-carbon-emission-basic-configuration-basic-configuration-module"
	],
	"@ehs/carbon-emission/basic-configuration/esg-indicators/esg-indicators.module": [
		"./src/app/ehs/carbon-emission/basic-configuration/esg-indicators/esg-indicators.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~d00498ce",
		"common",
		"ehs-carbon-emission-basic-configuration-esg-indicators-esg-indicators-module"
	],
	"@ehs/carbon-emission/basic-configuration/ghg-checklist/ghg-checklist.module": [
		"./src/app/ehs/carbon-emission/basic-configuration/ghg-checklist/ghg-checklist.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~94fe8c80",
		"common",
		"ehs-carbon-emission-basic-configuration-ghg-checklist-ghg-checklist-module"
	],
	"@ehs/carbon-emission/basic-configuration/ghg-coefficient/ghg-coefficient.module": [
		"./src/app/ehs/carbon-emission/basic-configuration/ghg-coefficient/ghg-coefficient.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~b0586a80",
		"common",
		"ehs-carbon-emission-basic-configuration-ghg-coefficient-ghg-coefficient-module"
	],
	"@ehs/carbon-emission/basic-configuration/ghg-source/ghg-source.module": [
		"./src/app/ehs/carbon-emission/basic-configuration/ghg-source/ghg-source.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~b7bcf106",
		"common",
		"ehs-carbon-emission-basic-configuration-ghg-source-ghg-source-module"
	],
	"@ehs/carbon-emission/carbon-check/carbon-check-record/carbon-check-record.module": [
		"./src/app/ehs/carbon-emission/carbon-check/carbon-check-record/carbon-check-record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-carbon-emission-carbon-check-carbon-check-record-carbon-check-record-module"
	],
	"@ehs/carbon-emission/carbon-check/carbon-check-report/carbon-check-report.module": [
		"./src/app/ehs/carbon-emission/carbon-check/carbon-check-report/carbon-check-report.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-carbon-emission-carbon-check-carbon-check-report-carbon-check-report-module"
	],
	"@ehs/carbon-emission/carbon-check/carbon-check.module": [
		"./src/app/ehs/carbon-emission/carbon-check/carbon-check.module.ts",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-carbon-check-carbon-check~44009934",
		"common",
		"ehs-carbon-emission-carbon-check-carbon-check-module"
	],
	"@ehs/carbon-emission/carbon-reduction/carbon-reduction.module": [
		"./src/app/ehs/carbon-emission/carbon-reduction/carbon-reduction.module.ts",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-carbon-reduction-carbon-r~727d6ad5",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-carbon-reduction-carbon-r~758c6ed6",
		"common",
		"ehs-carbon-emission-carbon-reduction-carbon-reduction-module"
	],
	"@ehs/carbon-emission/carbon-reduction/reduction-method/reduction-method.module": [
		"./src/app/ehs/carbon-emission/carbon-reduction/reduction-method/reduction-method.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-carbon-reduction-carbon-r~727d6ad5",
		"common",
		"ehs-carbon-emission-carbon-reduction-reduction-method-reduction-method-module"
	],
	"@ehs/carbon-emission/carbon-reduction/reduction-plan/reduction-plan.module": [
		"./src/app/ehs/carbon-emission/carbon-reduction/reduction-plan/reduction-plan.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-carbon-reduction-carbon-r~758c6ed6",
		"common",
		"ehs-carbon-emission-carbon-reduction-reduction-plan-reduction-plan-module"
	],
	"@ehs/carbon-emission/data-filling/co2-data-filling-record/co2-data-filling-record.module": [
		"./src/app/ehs/carbon-emission/data-filling/co2-data-filling-record/co2-data-filling-record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-data-filling-co2-data-fil~b4574ee7",
		"common",
		"ehs-carbon-emission-data-filling-co2-data-filling-record-co2-data-filling-record-module"
	],
	"@ehs/carbon-emission/data-filling/co2-data-filling/co2-data-filling.module": [
		"./src/app/ehs/carbon-emission/data-filling/co2-data-filling/co2-data-filling.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-data-filling-co2-data-fil~1c2471ea",
		"common",
		"ehs-carbon-emission-data-filling-co2-data-filling-co2-data-filling-module"
	],
	"@ehs/carbon-emission/data-filling/co2-historical-data-change/co2-historical-data-change.module": [
		"./src/app/ehs/carbon-emission/data-filling/co2-historical-data-change/co2-historical-data-change.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-carbon-emission-data-filling-co2-historical-data-change-co2-historical-data-change-module"
	],
	"@ehs/carbon-emission/data-filling/data-filling.module": [
		"./src/app/ehs/carbon-emission/data-filling/data-filling.module.ts",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-data-filling-co2-data-fil~b4574ee7",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-data-filling-co2-data-fil~1c2471ea",
		"common",
		"ehs-carbon-emission-data-filling-data-filling-module"
	],
	"@ehs/carbon-emission/progress-target-managemen/progress-target-managemen.module": [
		"./src/app/ehs/carbon-emission/progress-target-managemen/progress-target-managemen.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-carbon-emission-progress-target-managemen-progress-target-managemen-module"
	],
	"@ehs/carbon-emission/progress-target-template/progress-target-template.module": [
		"./src/app/ehs/carbon-emission/progress-target-template/progress-target-template.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-carbon-emission-progress-target-template-progress-target-template-module"
	],
	"@ehs/carbon-emission/report/dashboard/dashboard.module": [
		"./src/app/ehs/carbon-emission/report/dashboard/dashboard.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-carbon-emission-report-dashboard-dashboard-module~ehs-notification-announcement-announce~85903b88",
		"common",
		"ehs-carbon-emission-report-dashboard-dashboard-module"
	],
	"@ehs/carbon-emission/report/report.module": [
		"./src/app/ehs/carbon-emission/report/report.module.ts",
		"common",
		"ehs-carbon-emission-report-report-module"
	],
	"@ehs/carbon-emission/settings-target-managemen/settings-target-managemen.module": [
		"./src/app/ehs/carbon-emission/settings-target-managemen/settings-target-managemen.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-carbon-emission-settings-target-managemen-settings-target-managemen-module"
	],
	"@ehs/corrective-action/detail/corrective-action.module": [
		"./src/app/ehs/corrective-action/detail/corrective-action.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-ehs-risk-risk-module~ehs-corrective-action-detail-corrective-action-module~ehs-risk-cond~90c16981",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-incident-abnormal-event-report-abn~ae9ece80",
		"common",
		"ehs-corrective-action-detail-corrective-action-module"
	],
	"@ehs/corrective-action/list/corrective-action-record.module": [
		"./src/app/ehs/corrective-action/list/corrective-action-record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-corrective-action-list-corrective-action-record-module"
	],
	"@ehs/dashboard/assessment/assessment.module": [
		"./src/app/ehs/dashboard/assessment/assessment.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~4b932605",
		"common",
		"ehs-dashboard-assessment-assessment-module"
	],
	"@ehs/dashboard/atp/atp.module": [
		"./src/app/ehs/dashboard/atp/atp.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~4b932605",
		"common",
		"ehs-dashboard-atp-atp-module"
	],
	"@ehs/dashboard/fm-bi/fm-bi-kpi.module": [
		"./src/app/ehs/dashboard/fm-bi/fm-bi-kpi.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~4b932605",
		"default~ehs-dashboard-fm-bi-fm-bi-kpi-module~ehs-dashboard-fm-hc-fm-hc-kpi-module~ehs-dashboard-fs-k~a113976a",
		"common",
		"ehs-dashboard-fm-bi-fm-bi-kpi-module"
	],
	"@ehs/dashboard/fm-hc/fm-hc-kpi.module": [
		"./src/app/ehs/dashboard/fm-hc/fm-hc-kpi.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~4b932605",
		"default~ehs-dashboard-fm-bi-fm-bi-kpi-module~ehs-dashboard-fm-hc-fm-hc-kpi-module~ehs-dashboard-fs-k~a113976a",
		"common",
		"ehs-dashboard-fm-hc-fm-hc-kpi-module"
	],
	"@ehs/dashboard/food-safety/food-safety.module": [
		"./src/app/ehs/dashboard/food-safety/food-safety.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~4b932605",
		"common",
		"ehs-dashboard-food-safety-food-safety-module"
	],
	"@ehs/dashboard/fs-kpi/fs-kpi.module": [
		"./src/app/ehs/dashboard/fs-kpi/fs-kpi.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~4b932605",
		"default~ehs-dashboard-fm-bi-fm-bi-kpi-module~ehs-dashboard-fm-hc-fm-hc-kpi-module~ehs-dashboard-fs-k~a113976a",
		"common",
		"ehs-dashboard-fs-kpi-fs-kpi-module"
	],
	"@ehs/dashboard/hazard/hazard-dashboard.module": [
		"./src/app/ehs/dashboard/hazard/hazard-dashboard.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~4b932605",
		"common",
		"ehs-dashboard-hazard-hazard-dashboard-module"
	],
	"@ehs/dashboard/homepage/homepage.module": [
		"./src/app/ehs/dashboard/homepage/homepage.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~4b932605",
		"common",
		"ehs-dashboard-homepage-homepage-module"
	],
	"@ehs/dashboard/inspection-correction/inspection-correction.module": [
		"./src/app/ehs/dashboard/inspection-correction/inspection-correction.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~4b932605",
		"common",
		"ehs-dashboard-inspection-correction-inspection-correction-module"
	],
	"@ehs/dashboard/issue/issue.module": [
		"./src/app/ehs/dashboard/issue/issue.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~4b932605",
		"common",
		"ehs-dashboard-issue-issue-module"
	],
	"@ehs/dashboard/kpi-exemption/kpi-exemption.module": [
		"./src/app/ehs/dashboard/kpi-exemption/kpi-exemption.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-dashboard-kpi-exemption-kpi-exemption-module"
	],
	"@ehs/dashboard/new-training/new-training.module": [
		"./src/app/ehs/dashboard/new-training/new-training.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~4b932605",
		"common",
		"ehs-dashboard-new-training-new-training-module"
	],
	"@ehs/dashboard/regulation/regulation-dashboard.module": [
		"./src/app/ehs/dashboard/regulation/regulation-dashboard.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"common",
		"ehs-dashboard-regulation-regulation-dashboard-module"
	],
	"@ehs/dashboard/risk-assessment/risk-assessment-dashboard.module": [
		"./src/app/ehs/dashboard/risk-assessment/risk-assessment-dashboard.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"common",
		"ehs-dashboard-risk-assessment-risk-assessment-dashboard-module"
	],
	"@ehs/dashboard/training/training-dashboard.module": [
		"./src/app/ehs/dashboard/training/training-dashboard.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-dashboard-assessment-assessment-module~ehs-dashboard-atp-atp-module~ehs-dashboard-fm-bi-~c9117344",
		"default~ehs-dashboard-fm-bi-fm-bi-kpi-module~ehs-dashboard-fm-hc-fm-hc-kpi-module~ehs-dashboard-fs-k~a113976a",
		"default~ehs-dashboard-training-training-dashboard-module~ehs-training-class-class-module",
		"common",
		"ehs-dashboard-training-training-dashboard-module"
	],
	"@ehs/dashboard/white-list/white-list.module": [
		"./src/app/ehs/dashboard/white-list/white-list.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-dashboard-white-list-white-list-module"
	],
	"@ehs/doctor-satisfaction/qr-code/qr-code.module": [
		"./src/app/ehs/doctor-satisfaction/qr-code/qr-code.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-doctor-satisfaction-qr-code-qr-code-module"
	],
	"@ehs/doctor-satisfaction/satisfaction/satisfaction.module": [
		"./src/app/ehs/doctor-satisfaction/satisfaction/satisfaction.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-doctor-satisfaction-satisfaction-satisfaction-module"
	],
	"@ehs/documentation/doc-classification/doc-classification.module": [
		"./src/app/ehs/documentation/doc-classification/doc-classification.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-documentation-doc-classification-doc-classification-module"
	],
	"@ehs/documentation/doc-list/doc-list.module": [
		"./src/app/ehs/documentation/doc-list/doc-list.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-documentation-doc-list-doc-list-module"
	],
	"@ehs/documentation/doc-management/doc-management.module": [
		"./src/app/ehs/documentation/doc-management/doc-management.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-documentation-documentation-module~ehs-documentation-doc-management-doc-management-m~d4f7ef9a",
		"common",
		"ehs-documentation-doc-management-doc-management-module"
	],
	"@ehs/incident/abnormal-event-report/abnormal-event-report.module": [
		"./src/app/ehs/incident/abnormal-event-report/abnormal-event-report.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~799a8095",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~436385d9",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~6416ec2d",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-incident-abnormal-event-report-abn~ae9ece80",
		"default~app-ehs-incident-incident-module~ehs-incident-abnormal-event-report-abnormal-event-report-mo~1407ba02",
		"common",
		"ehs-incident-abnormal-event-report-abnormal-event-report-module"
	],
	"@ehs/incident/hazard-report/hazard-report.module": [
		"./src/app/ehs/incident/hazard-report/hazard-report.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-incident-hazard-report-hazard-report-module"
	],
	"@ehs/incident/incident-diagnostic/incident-diagnostic.module": [
		"./src/app/ehs/incident/incident-diagnostic/incident-diagnostic.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~799a8095",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~436385d9",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~6416ec2d",
		"default~app-ehs-incident-incident-module~ehs-incident-abnormal-event-report-abnormal-event-report-mo~1407ba02",
		"default~app-ehs-incident-incident-module~ehs-incident-incident-diagnostic-incident-diagnostic-module~754f938e",
		"default~ehs-incident-incident-diagnostic-incident-diagnostic-module~ehs-incident-incident-report-inc~6a06c5e8",
		"common",
		"ehs-incident-incident-diagnostic-incident-diagnostic-module"
	],
	"@ehs/incident/incident-inquiry/incident-inquiry.module": [
		"./src/app/ehs/incident/incident-inquiry/incident-inquiry.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-incident-incident-inquiry-incident-inquiry-module"
	],
	"@ehs/incident/incident-investigation/incident-investigation.module": [
		"./src/app/ehs/incident/incident-investigation/incident-investigation.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~799a8095",
		"common",
		"ehs-incident-incident-investigation-incident-investigation-module"
	],
	"@ehs/incident/incident-report/incident-report.module": [
		"./src/app/ehs/incident/incident-report/incident-report.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~799a8095",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~436385d9",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~6416ec2d",
		"default~app-ehs-incident-incident-module~ehs-incident-incident-diagnostic-incident-diagnostic-module~754f938e",
		"default~ehs-incident-incident-diagnostic-incident-diagnostic-module~ehs-incident-incident-report-inc~6a06c5e8",
		"default~app-ehs-incident-incident-module~ehs-incident-incident-report-incident-report-module",
		"common",
		"ehs-incident-incident-report-incident-report-module"
	],
	"@ehs/incident/injured-people/injured-people.module": [
		"./src/app/ehs/incident/injured-people/injured-people.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~799a8095",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~436385d9",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~6416ec2d",
		"common",
		"ehs-incident-injured-people-injured-people-module"
	],
	"@ehs/incident/injury-record/injury-record.module": [
		"./src/app/ehs/incident/injury-record/injury-record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-incident-incident-module~ehs-incident-injury-record-injury-record-module",
		"common",
		"ehs-incident-injury-record-injury-record-module"
	],
	"@ehs/incident/working-day/working-day.module": [
		"./src/app/ehs/incident/working-day/working-day.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-incident-working-day-working-day-module"
	],
	"@ehs/incident/working-hours/working-hours.module": [
		"./src/app/ehs/incident/working-hours/working-hours.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-incident-incident-module~ehs-incident-working-hours-working-hours-module",
		"common",
		"ehs-incident-working-hours-working-hours-module"
	],
	"@ehs/inspection/ad-hoc-inspection/ad-hoc-inspection.module": [
		"./src/app/ehs/inspection/ad-hoc-inspection/ad-hoc-inspection.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~5efa25ec",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~799a8095",
		"default~ehs-incident-abnormal-event-report-abnormal-event-report-module~ehs-incident-incident-diagno~436385d9",
		"common",
		"ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module"
	],
	"@ehs/inspection/corrective-action-record-issue/corrective-action-record.module": [
		"./src/app/ehs/inspection/corrective-action-record-issue/corrective-action-record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-inspection-corrective-action-record-issue-corrective-action-record-module"
	],
	"@ehs/inspection/corrective-action-record/corrective-action-record.module": [
		"./src/app/ehs/inspection/corrective-action-record/corrective-action-record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-inspection-corrective-action-record-corrective-action-record-module"
	],
	"@ehs/inspection/corrective-action/corrective-action.module": [
		"./src/app/ehs/inspection/corrective-action/corrective-action.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~5efa25ec",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-corrective-action-corrective-action-modu~f5e42bee",
		"common",
		"ehs-inspection-corrective-action-corrective-action-module"
	],
	"@ehs/inspection/gov-corrective-action-record/corrective-action-record.module": [
		"./src/app/ehs/inspection/gov-corrective-action-record/corrective-action-record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-inspection-gov-corrective-action-record-corrective-action-record-module"
	],
	"@ehs/inspection/gov-inspection-reporting/gov-inspection-reporting.module": [
		"./src/app/ehs/inspection/gov-inspection-reporting/gov-inspection-reporting.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~5efa25ec",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"common",
		"ehs-inspection-gov-inspection-reporting-gov-inspection-reporting-module"
	],
	"@ehs/inspection/gov-inspection/gov-inspection.module": [
		"./src/app/ehs/inspection/gov-inspection/gov-inspection.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~5efa25ec",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-gov-inspection-gov-inspection-module",
		"common",
		"ehs-inspection-gov-inspection-gov-inspection-module"
	],
	"@ehs/inspection/gov-penalty/gov-penalty.module": [
		"./src/app/ehs/inspection/gov-penalty/gov-penalty.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~5efa25ec",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"common",
		"ehs-inspection-gov-penalty-gov-penalty-module"
	],
	"@ehs/inspection/inspection-record/inspection-record.module": [
		"./src/app/ehs/inspection/inspection-record/inspection-record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-inspection-record-inspection-record-modu~290a16c1",
		"common",
		"ehs-inspection-inspection-record-inspection-record-module"
	],
	"@ehs/inspection/inspection-scheduling/inspection-scheduling.module": [
		"./src/app/ehs/inspection/inspection-scheduling/inspection-scheduling.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-inspection-scheduling-inspection-schedul~0f761666",
		"common",
		"ehs-inspection-inspection-scheduling-inspection-scheduling-module"
	],
	"@ehs/inspection/issue-record/issue-record.module": [
		"./src/app/ehs/inspection/issue-record/issue-record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~5efa25ec",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-issue-record-issue-record-module",
		"common",
		"ehs-inspection-issue-record-issue-record-module"
	],
	"@ehs/inspection/issue-reporting/issue-reporting.module": [
		"./src/app/ehs/inspection/issue-reporting/issue-reporting.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~5efa25ec",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"common",
		"ehs-inspection-issue-reporting-issue-reporting-module"
	],
	"@ehs/inspection/non-scheduled-inspection/non-scheduled-inspection.module": [
		"./src/app/ehs/inspection/non-scheduled-inspection/non-scheduled-inspection.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~5efa25ec",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-non-scheduled-inspection-non-scheduled-i~6f1056cf",
		"common",
		"ehs-inspection-non-scheduled-inspection-non-scheduled-inspection-module"
	],
	"@ehs/inspection/reported-issue/reported-issue.module": [
		"./src/app/ehs/inspection/reported-issue/reported-issue.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~5efa25ec",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-reported-issue-reported-issue-module",
		"common",
		"ehs-inspection-reported-issue-reported-issue-module"
	],
	"@ehs/inspection/scheduled-inspection/scheduled-inspection.module": [
		"./src/app/ehs/inspection/scheduled-inspection/scheduled-inspection.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~5efa25ec",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~eaa39c3d",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-scheduled-inspection-scheduled-inspectio~6711bed3",
		"common",
		"ehs-inspection-scheduled-inspection-scheduled-inspection-module"
	],
	"@ehs/medical-service/job-assessment/job-assessment.module": [
		"./src/app/ehs/medical-service/job-assessment/job-assessment.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-medical-service-medical-service-module~ehs-medical-service-job-assessment-job-assess~9adc9086",
		"common",
		"ehs-medical-service-job-assessment-job-assessment-module"
	],
	"@ehs/medical-service/satisfaction/satisfaction.module": [
		"./src/app/ehs/medical-service/satisfaction/satisfaction.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-medical-service-medical-service-module~ehs-medical-service-satisfaction-satisfaction~a51ba00c",
		"common",
		"ehs-medical-service-satisfaction-satisfaction-module"
	],
	"@ehs/medical-service/scheduled-inspection/scheduled-inspection.module": [
		"./src/app/ehs/medical-service/scheduled-inspection/scheduled-inspection.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-medical-service-medical-service-module~ehs-medical-service-scheduled-inspection-sche~1d91a8d9",
		"common",
		"ehs-medical-service-scheduled-inspection-scheduled-inspection-module"
	],
	"@ehs/medical-service/space-inspection/space-inspection.module": [
		"./src/app/ehs/medical-service/space-inspection/space-inspection.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-medical-service-medical-service-module~ehs-medical-service-space-inspection-space-in~e8f41c93",
		"common",
		"ehs-medical-service-space-inspection-space-inspection-module"
	],
	"@ehs/notification/announcement/announcement.module": [
		"./src/app/ehs/notification/announcement/announcement.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-carbon-emission-report-dashboard-dashboard-module~ehs-notification-announcement-announce~85903b88",
		"default~app-ehs-notification-notification-module~ehs-notification-announcement-announcement-module",
		"default~ehs-notification-announcement-announcement-module~ehs-training-lesson-lesson-module",
		"common",
		"ehs-notification-announcement-announcement-module"
	],
	"@ehs/notification/message-group/message-group.module": [
		"./src/app/ehs/notification/message-group/message-group.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-notification-message-group-message-group-module"
	],
	"@ehs/qpe/corrective-action/corrective-action.module": [
		"./src/app/ehs/qpe/corrective-action/corrective-action.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-qpe-qpe-module~ehs-qpe-corrective-action-corrective-action-module",
		"common",
		"ehs-qpe-corrective-action-corrective-action-module"
	],
	"@ehs/qpe/qpe-inspection/qpe-inspection.module": [
		"./src/app/ehs/qpe/qpe-inspection/qpe-inspection.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-qpe-qpe-inspection-qpe-inspection-module"
	],
	"@ehs/qpe/qpe-query/qpe-query.module": [
		"./src/app/ehs/qpe/qpe-query/qpe-query.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~app-ehs-qpe-qpe-module~ehs-qpe-qpe-query-qpe-query-module",
		"common",
		"ehs-qpe-qpe-query-qpe-query-module"
	],
	"@ehs/regulation/activity/activity.module": [
		"./src/app/ehs/regulation/activity/activity.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module~ehs-regulati~f8440154",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module",
		"common",
		"ehs-regulation-activity-activity-module"
	],
	"@ehs/regulation/database/database.module": [
		"./src/app/ehs/regulation/database/database.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module~ehs-regulati~f8440154",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module",
		"common",
		"ehs-regulation-database-database-module"
	],
	"@ehs/regulation/improvement/improvement.module": [
		"./src/app/ehs/regulation/improvement/improvement.module.ts",
		"common",
		"ehs-regulation-improvement-improvement-module"
	],
	"@ehs/regulation/improvement/list/list.module": [
		"./src/app/ehs/regulation/improvement/list/list.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module~ehs-regulati~f8440154",
		"common",
		"ehs-regulation-improvement-list-list-module"
	],
	"@ehs/regulation/task/cooperation/cooperation.module": [
		"./src/app/ehs/regulation/task/cooperation/cooperation.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module~ehs-regulati~f8440154",
		"common",
		"ehs-regulation-task-cooperation-cooperation-module"
	],
	"@ehs/regulation/task/list/list.module": [
		"./src/app/ehs/regulation/task/list/list.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-regulation-activity-activity-module~ehs-regulation-database-database-module~ehs-regulati~f8440154",
		"common",
		"ehs-regulation-task-list-list-module"
	],
	"@ehs/regulation/task/task.module": [
		"./src/app/ehs/regulation/task/task.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-regulation-task-task-module"
	],
	"@ehs/risk/conduct-job-record/conduct-job-record.module": [
		"./src/app/ehs/risk/conduct-job-record/conduct-job-record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-risk-conduct-job-record-conduct-job-record-module"
	],
	"@ehs/risk/conduct/conduct.module": [
		"./src/app/ehs/risk/conduct/conduct.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~app-ehs-risk-risk-module~ehs-corrective-action-detail-corrective-action-module~ehs-risk-cond~90c16981",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-incident-abnormal-event-report-abn~ae9ece80",
		"default~app-ehs-risk-risk-module~ehs-risk-conduct-conduct-module~ehs-risk-matrix-matrix-module",
		"default~ehs-risk-conduct-conduct-module~ehs-risk-job-task-job-task-module~ehs-risk-planning-planning~4f74667a",
		"default~ehs-risk-conduct-conduct-module~ehs-risk-job-task-job-task-module",
		"common",
		"ehs-risk-conduct-conduct-module"
	],
	"@ehs/risk/job-task/job-task.module": [
		"./src/app/ehs/risk/job-task/job-task.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-risk-risk-module~ehs-risk-job-task-job-task-module~ehs-risk-matrix-matrix-module",
		"default~ehs-risk-conduct-conduct-module~ehs-risk-job-task-job-task-module~ehs-risk-planning-planning~4f74667a",
		"default~ehs-risk-conduct-conduct-module~ehs-risk-job-task-job-task-module",
		"common",
		"ehs-risk-job-task-job-task-module"
	],
	"@ehs/risk/matrix/matrix.module": [
		"./src/app/ehs/risk/matrix/matrix.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-risk-risk-module~ehs-corrective-action-detail-corrective-action-module~ehs-risk-cond~90c16981",
		"default~app-ehs-risk-risk-module~ehs-risk-conduct-conduct-module~ehs-risk-matrix-matrix-module",
		"default~app-ehs-risk-risk-module~ehs-risk-job-task-job-task-module~ehs-risk-matrix-matrix-module",
		"default~app-ehs-risk-risk-module~ehs-risk-matrix-matrix-module~ehs-risk-planning-planning-module",
		"default~app-ehs-risk-risk-module~ehs-risk-matrix-matrix-module",
		"common",
		"ehs-risk-matrix-matrix-module"
	],
	"@ehs/risk/planning/planning.module": [
		"./src/app/ehs/risk/planning/planning.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-risk-risk-module~ehs-risk-matrix-matrix-module~ehs-risk-planning-planning-module",
		"default~ehs-risk-conduct-conduct-module~ehs-risk-job-task-job-task-module~ehs-risk-planning-planning~4f74667a",
		"common",
		"ehs-risk-planning-planning-module"
	],
	"@ehs/statistics/dashboard/dashboard.module": [
		"./src/app/ehs/statistics/dashboard/dashboard.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"default~ehs-carbon-emission-report-dashboard-dashboard-module~ehs-notification-announcement-announce~85903b88",
		"common",
		"ehs-statistics-dashboard-dashboard-module"
	],
	"@ehs/system-setting/employee/employee.module": [
		"./src/app/ehs/system-setting/employee/employee.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-inspection-ad-hoc-inspection-ad-hoc-inspection-module~ehs-inspection-corrective-action-c~5efa25ec",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-employee-employee-module",
		"common",
		"ehs-system-setting-employee-employee-module"
	],
	"@ehs/system-setting/form-management/form-management.module": [
		"./src/app/ehs/system-setting/form-management/form-management.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-form-management-form-managem~62dc5505",
		"common",
		"ehs-system-setting-form-management-form-management-module"
	],
	"@ehs/system-setting/organization/organization.module": [
		"./src/app/ehs/system-setting/organization/organization.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-organization-organization-mo~d1f27257",
		"common",
		"ehs-system-setting-organization-organization-module"
	],
	"@ehs/system-setting/physical-structure/facility/facility.module": [
		"./src/app/ehs/system-setting/physical-structure/facility/facility.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-physical-structure-facility-~3ec66631",
		"common",
		"ehs-system-setting-physical-structure-facility-facility-module"
	],
	"@ehs/system-setting/physical-structure/physical-structure.module": [
		"./src/app/ehs/system-setting/physical-structure/physical-structure.module.ts",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-physical-structure-facility-~3ec66631",
		"common",
		"ehs-system-setting-physical-structure-physical-structure-module"
	],
	"@ehs/system-setting/question-bank/question-bank.module": [
		"./src/app/ehs/system-setting/question-bank/question-bank.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-question-bank-question-bank-~d38b3fed",
		"common",
		"ehs-system-setting-question-bank-question-bank-module"
	],
	"@ehs/system-setting/role-management/role-management.module": [
		"./src/app/ehs/system-setting/role-management/role-management.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-system-setting-role-management-role-management-module"
	],
	"@ehs/system-setting/space-group/space-group.module": [
		"./src/app/ehs/system-setting/space-group/space-group.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-system-setting-space-group-space-group-module"
	],
	"@ehs/system-setting/space-type/space-type.module": [
		"./src/app/ehs/system-setting/space-type/space-type.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-system-setting-space-type-space-type-module"
	],
	"@ehs/system-setting/space/space.module": [
		"./src/app/ehs/system-setting/space/space.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-system-setting-space-space-module"
	],
	"@ehs/system-setting/system-code/system-code.module": [
		"./src/app/ehs/system-setting/system-code/system-code.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-system-setting-system-code-system-code-module"
	],
	"@ehs/training/calendar/calendar.module": [
		"./src/app/ehs/training/calendar/calendar.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-training-calendar-calendar-module"
	],
	"@ehs/training/certificate-category/certificate-category.module": [
		"./src/app/ehs/training/certificate-category/certificate-category.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~953f08d8",
		"common"
	],
	"@ehs/training/certificate/certificate.module": [
		"./src/app/ehs/training/certificate/certificate.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~953f08d8",
		"common",
		"ehs-training-certificate-certificate-module"
	],
	"@ehs/training/class/class.module": [
		"./src/app/ehs/training/class/class.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-dashboard-training-training-dashboard-module~ehs-training-class-class-module",
		"common",
		"ehs-training-class-class-module"
	],
	"@ehs/training/exemption/exemption.module": [
		"./src/app/ehs/training/exemption/exemption.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-training-exemption-exemption-module"
	],
	"@ehs/training/instructor/instructor.module": [
		"./src/app/ehs/training/instructor/instructor.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-training-instructor-instructor-module"
	],
	"@ehs/training/lesson/lesson.module": [
		"./src/app/ehs/training/lesson/lesson.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"default~ehs-training-lesson-lesson-module~ehs-training-train-record-train-record-module",
		"default~ehs-notification-announcement-announcement-module~ehs-training-lesson-lesson-module",
		"common",
		"ehs-training-lesson-lesson-module"
	],
	"@ehs/training/my-course/my-course.module": [
		"./src/app/ehs/training/my-course/my-course.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"common",
		"ehs-training-my-course-my-course-module"
	],
	"@ehs/training/question-set/question-set.module": [
		"./src/app/ehs/training/question-set/question-set.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"common",
		"ehs-training-question-set-question-set-module"
	],
	"@ehs/training/quiz/quiz.module": [
		"./src/app/ehs/training/quiz/quiz.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"common",
		"ehs-training-quiz-quiz-module"
	],
	"@ehs/training/record/record.module": [
		"./src/app/ehs/training/record/record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-training-record-record-module"
	],
	"@ehs/training/sign-table/sign-table.module": [
		"./src/app/ehs/training/sign-table/sign-table.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-training-certificate-category-certificate-category-module~ehs-training-certificate-certi~ee8adc35",
		"common",
		"ehs-training-sign-table-sign-table-module"
	],
	"@ehs/training/train-record/train-record.module": [
		"./src/app/ehs/training/train-record/train-record.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~ehs-corrective-action-detail-corrective-action-module~ehs-dashboard-assessment-assessment-mo~db62bdaf",
		"default~ehs-training-lesson-lesson-module~ehs-training-train-record-train-record-module",
		"common",
		"ehs-training-train-record-train-record-module"
	],
	"app/auth/auth.module": [
		"./src/app/auth/auth.module.ts"
	],
	"app/co2-data-list/co2-data-list.module": [
		"./src/app/co2-data-list/co2-data-list.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"app-co2-data-list-co2-data-list-module"
	],
	"app/corrective-action/corrective-action.module": [
		"./src/app/corrective-action/corrective-action.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"app-corrective-action-corrective-action-module"
	],
	"app/doc-list/doc-list.module": [
		"./src/app/doc-list/doc-list.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"app-doc-list-doc-list-module"
	],
	"app/doc-management/doc-management.module": [
		"./src/app/doc-management/doc-management.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"app-doc-management-doc-management-module"
	],
	"app/ehs/carbon-emission/carbon-emission.module": [
		"./src/app/ehs/carbon-emission/carbon-emission.module.ts",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-data-filling-co2-data-fil~b4574ee7",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~94fe8c80",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-carbon-reduction-carbon-r~727d6ad5",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~b7bcf106",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-data-filling-co2-data-fil~1c2471ea",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-carbon-reduction-carbon-r~758c6ed6",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~b0586a80",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-basic~d00498ce",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-basic-configuration-api-m~811ec30c",
		"default~app-ehs-carbon-emission-carbon-emission-module~ehs-carbon-emission-carbon-check-carbon-check~44009934",
		"common",
		"app-ehs-carbon-emission-carbon-emission-module"
	],
	"app/ehs/carbon-emission/data-filling/co2-historical-data-change/co2-historical-data-change.module": [
		"./src/app/ehs/carbon-emission/data-filling/co2-historical-data-change/co2-historical-data-change.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"ehs-carbon-emission-data-filling-co2-historical-data-change-co2-historical-data-change-module"
	],
	"app/ehs/dashboard/dashboard.module": [
		"./src/app/ehs/dashboard/dashboard.module.ts",
		"app-ehs-dashboard-dashboard-module"
	],
	"app/ehs/doctor-satisfaction/doctor-satisfaction.module": [
		"./src/app/ehs/doctor-satisfaction/doctor-satisfaction.module.ts",
		"common",
		"app-ehs-doctor-satisfaction-doctor-satisfaction-module"
	],
	"app/ehs/documentation/documentation.module": [
		"./src/app/ehs/documentation/documentation.module.ts",
		"default~app-ehs-documentation-documentation-module~ehs-documentation-doc-management-doc-management-m~d4f7ef9a",
		"common",
		"app-ehs-documentation-documentation-module"
	],
	"app/ehs/ehs.module": [
		"./src/app/ehs/ehs.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"common",
		"app-ehs-ehs-module"
	],
	"app/ehs/incident/incident.module": [
		"./src/app/ehs/incident/incident.module.ts",
		"default~app-ehs-incident-incident-module~ehs-incident-abnormal-event-report-abnormal-event-report-mo~1407ba02",
		"default~app-ehs-incident-incident-module~ehs-incident-incident-diagnostic-incident-diagnostic-module~754f938e",
		"default~app-ehs-incident-incident-module~ehs-incident-incident-report-incident-report-module",
		"default~app-ehs-incident-incident-module~ehs-incident-injury-record-injury-record-module",
		"default~app-ehs-incident-incident-module~ehs-incident-working-hours-working-hours-module",
		"common",
		"app-ehs-incident-incident-module"
	],
	"app/ehs/inspection/inspection.module": [
		"./src/app/ehs/inspection/inspection.module.ts",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-scheduled-inspection-scheduled-inspectio~6711bed3",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-inspection-scheduling-inspection-schedul~0f761666",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-corrective-action-corrective-action-modu~f5e42bee",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-non-scheduled-inspection-non-scheduled-i~6f1056cf",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-reported-issue-reported-issue-module",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-issue-record-issue-record-module",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-gov-inspection-gov-inspection-module",
		"default~app-ehs-inspection-inspection-module~ehs-inspection-inspection-record-inspection-record-modu~290a16c1",
		"common",
		"app-ehs-inspection-inspection-module"
	],
	"app/ehs/medical-service/medical-service.module": [
		"./src/app/ehs/medical-service/medical-service.module.ts",
		"default~app-ehs-medical-service-medical-service-module~ehs-medical-service-scheduled-inspection-sche~1d91a8d9",
		"default~app-ehs-medical-service-medical-service-module~ehs-medical-service-space-inspection-space-in~e8f41c93",
		"default~app-ehs-medical-service-medical-service-module~ehs-medical-service-job-assessment-job-assess~9adc9086",
		"default~app-ehs-medical-service-medical-service-module~ehs-medical-service-satisfaction-satisfaction~a51ba00c",
		"common",
		"app-ehs-medical-service-medical-service-module"
	],
	"app/ehs/message-center/message-center.module": [
		"./src/app/ehs/message-center/message-center.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"app-ehs-message-center-message-center-module"
	],
	"app/ehs/notification/notification.module": [
		"./src/app/ehs/notification/notification.module.ts",
		"default~app-ehs-notification-notification-module~ehs-notification-announcement-announcement-module",
		"common",
		"app-ehs-notification-notification-module"
	],
	"app/ehs/qpe/qpe.module": [
		"./src/app/ehs/qpe/qpe.module.ts",
		"default~app-ehs-qpe-qpe-module~ehs-qpe-qpe-query-qpe-query-module",
		"default~app-ehs-qpe-qpe-module~ehs-qpe-corrective-action-corrective-action-module",
		"common",
		"app-ehs-qpe-qpe-module"
	],
	"app/ehs/regulation/regulation.module": [
		"./src/app/ehs/regulation/regulation.module.ts",
		"app-ehs-regulation-regulation-module"
	],
	"app/ehs/risk/risk.module": [
		"./src/app/ehs/risk/risk.module.ts",
		"default~app-ehs-risk-risk-module~ehs-corrective-action-detail-corrective-action-module~ehs-risk-cond~90c16981",
		"default~app-ehs-risk-risk-module~ehs-risk-conduct-conduct-module~ehs-risk-matrix-matrix-module",
		"default~app-ehs-risk-risk-module~ehs-risk-job-task-job-task-module~ehs-risk-matrix-matrix-module",
		"default~app-ehs-risk-risk-module~ehs-risk-matrix-matrix-module~ehs-risk-planning-planning-module",
		"default~app-ehs-risk-risk-module~ehs-risk-matrix-matrix-module",
		"common",
		"app-ehs-risk-risk-module"
	],
	"app/ehs/safety-observation/safety-observation.module": [
		"./src/app/ehs/safety-observation/safety-observation.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"common",
		"app-ehs-safety-observation-safety-observation-module"
	],
	"app/ehs/statistics/statistics.module": [
		"./src/app/ehs/statistics/statistics.module.ts",
		"common",
		"app-ehs-statistics-statistics-module"
	],
	"app/ehs/system-setting/system-setting.module": [
		"./src/app/ehs/system-setting/system-setting.module.ts",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-physical-structure-facility-~3ec66631",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-employee-employee-module",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-form-management-form-managem~62dc5505",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-organization-organization-mo~d1f27257",
		"default~app-ehs-system-setting-system-setting-module~ehs-system-setting-question-bank-question-bank-~d38b3fed",
		"common",
		"app-ehs-system-setting-system-setting-module"
	],
	"app/ehs/task-center/task-center.module": [
		"./src/app/ehs/task-center/task-center.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"app-ehs-task-center-task-center-module"
	],
	"app/ehs/training/training.module": [
		"./src/app/ehs/training/training.module.ts",
		"app-ehs-training-training-module"
	],
	"app/inspection-issue/inspection-issue.module": [
		"./src/app/inspection-issue/inspection-issue.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"app-inspection-issue-inspection-issue-module"
	],
	"app/quantum-theme/views/themes/quantum/theme.module": [
		"./src/app/quantum-theme/views/themes/quantum/theme.module.ts",
		"app-quantum-theme-views-themes-quantum-theme-module"
	],
	"app/scheduled-inspection-task/scheduled-inspection-task.module": [
		"./src/app/scheduled-inspection-task/scheduled-inspection-task.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"app-scheduled-inspection-task-scheduled-inspection-task-module"
	],
	"app/screen-dashboard/screen-dashboard.module": [
		"./src/app/screen-dashboard/screen-dashboard.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"default~app-screen-dashboard-screen-dashboard-module~ehs-carbon-emission-report-dashboard-dashboard-~6e4afc93",
		"common",
		"app-screen-dashboard-screen-dashboard-module"
	],
	"app/share-inspection/share-inspection.module": [
		"./src/app/share-inspection/share-inspection.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"app-share-inspection-share-inspection-module"
	],
	"app/task-center/task-center.module": [
		"./src/app/task-center/task-center.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"app-task-center-task-center-module"
	],
	"app/yuyuan-login/yuyuan-login.module": [
		"./src/app/yuyuan-login/yuyuan-login.module.ts",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~91eaf5cb",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~80c0ffb5",
		"default~app-co2-data-list-co2-data-list-module~app-corrective-action-corrective-action-module~app-do~a00c5155",
		"common",
		"app-yuyuan-login-yuyuan-login-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;